// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_cx-j";
export var fulfillmentFormRail = "_cx-i";
export var headerTitleRow = "_cx-l";
export var orderDetailsWrapper = "_cx-g";
export var orderLinkTrigger = "_cx-2";
export var paymentInformationGrid = "_cx-q";
export var paymentSummaryColumn = "_cx-r";
export var phoneShipmentPickerButton = "_cx-e";
export var phoneShipmentPickerButtonContent = "_cx-f";
export var phoneShipmentPickerButtonWrapper = "_cx-d";
export var phoneShipmentPickerTrigger = "_cx-c";
export var shipmentContainer = "_cx-k";
export var shipmentDetailsMainPane = "_cx-h";
export var shipmentNavigationCard = "_cx-a";
export var shipmentNavigationEdgeTrigger = "_cx-6";
export var shipmentNavigationRail = "_cx-3";
export var shipmentNavigationRailEnter = "_cx-5";
export var shipmentNavigationRailHeader = "_cx-9";
export var shipmentNavigationRailOverlay = "_cx-4";
export var shipmentNavigationScrim = "_cx-7";
export var shipmentSummaryFact = "_cx-n";
export var shipmentSummaryGrid = "_cx-m";
export var shipmentSummaryMetadataRow = "_cx-o";
export var shipmentSummaryTags = "_cx-p";
export var shipmentWorkspace = "_cx-0";
export var shipmentWorkspaceBodyTablet = "_cx-8";
export var shipmentWorkspaceContent = "_cx-b";
export var shipmentWorkspaceHeader = "_cx-1";